import React, { useEffect, useRef } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { CreateAdoApp } from '../CreateAdoApp/CreateAdoAppExtension';
import { SelectAdoApp } from '../SelectAdoApp/SelectAdoAppExtension';

/**
 * Switches between creating a new app name and selecting an existing app
 * from the product, based on the "operation" form field.
 */
export const ReplitAppField = (props: FieldExtensionComponentProps<string>) => {
  const { onChange, formContext, schema } = props;
  const operation = formContext?.formData?.operation ?? 'create';
  const prevOperationRef = useRef(operation);

  useEffect(() => {
    if (prevOperationRef.current !== operation) {
      onChange('');
      prevOperationRef.current = operation;
    }
  }, [operation, onChange]);

  if (operation === 'update') {
    return (
      <SelectAdoApp
        {...props}
        schema={{
          ...schema,
          title: schema.title || 'Replit App',
          description:
            schema.description ||
            'Select an existing application from this product',
        }}
      />
    );
  }

  return <CreateAdoApp {...props} />;
};
